import { render, staticRenderFns } from "./staffs.vue?vue&type=template&id=e0ef4b9a&scoped=true&"
import script from "./staffs.vue?vue&type=script&lang=js&"
export * from "./staffs.vue?vue&type=script&lang=js&"
import style0 from "./staffs.vue?vue&type=style&index=0&id=e0ef4b9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ef4b9a",
  null
  
)

export default component.exports